import services from '../../../../services';

export default {
  /**
   * Busca todas as situações
   * @returns {Promise<object[]>}
   */
  async bucarSituacoes() {
    const body = {};
    try {
      const res = await services.post(
        'Eventos',
        'buscar-situacoes-evento',
        body,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * cria uma situacão evento
   * @param {object} situacoes objeto situação
   * @returns {Promise<object>}
   */
  async criarSituacoes(situacao) {
    try {
      const body = { situacao };
      const res = await services.post(
        'Eventos',
        'criar-situacoes-evento',
        body,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * atualiza as situacoes passadas
   * @param {array} situacoes objetos situaçõe em um array
   * @returns {Promise<object>}
   */
  async atualizarSituacoes(situacoes) {
    try {
      const body = { situacoes };
      const res = await services.post(
        'Eventos',
        'atualizar-situacoes-evento',
        body,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  /**
   * Busca todos os motivos
   * @returns {Promise<object>}
   */
  async bucarMotivos() {
    const body = {};
    try {
      const res = await services.post('Eventos', 'buscar-motivos-evento', body);
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * cria um motivo de evento
   * @param {object} motivo objeto motivo
   * @returns {Promise<object>}
   */
  async criarMotivos(motivo) {
    try {
      const body = { motivo };
      const res = await services.post('Eventos', 'criar-motivos-evento', body);
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * atualiza os motivos passados
   * @param {array} motivos objetos motivos em um array
   * @returns {Promise<object>}
   */
  async atualizarMotivos(motivos) {
    try {
      const body = { motivos };
      const res = await services.post(
        'Eventos',
        'atualizar-motivos-evento',
        body,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
